import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { JobCardList } from '@components-v2/molecules/JobCardList'
import { JobBase } from '@/types'
import { NoContent } from '@components-v2/atoms/NoContent'
import styles from './index.module.scss'

type Props = {
  jobs: JobBase[]
}

// TODO start-up jobs のデザインがまだないので、jobs を受け取って JobCardList をそのままでも使用。
export const UserProfileStartUpJobs: FC<Props> = ({ jobs = [] }) => {
  const { t } = useTranslation(['jobs'])
  if (jobs.length === 0) {
    return <NoContent>{t('求人はまだ掲載されていません。')}</NoContent>
  }

  return (
    <div className={styles.container}>
      <JobCardList jobs={jobs} />
    </div>
  )
}
